import { Box, Button, Container, Paper } from '@mui/material'
import { useContext } from 'react'
import { Helmet } from 'react-helmet'
import JsonView from 'react-json-view'
import { Link } from 'react-router-dom'

import { StatsContext, StatsLoader } from '../Contexts'
import WorldBasePage from './WorldBasePage'

const Details: React.FC = () => {
  const statsContext = useContext(StatsContext)

  const onRefreshClicked = () => {
    statsContext?.refresh?.()
  }

  const statsJson = {
    geotokensMinted: statsContext?.geotokensMinted,
    totalBidders: statsContext?.totalBidders,
    totalBids: statsContext?.totalBids,
    totalXyoBid: statsContext?.totalXyoBid?.toString(10),
    totalXyoBurned: statsContext?.totalXyoBurned?.toString(10),
    totalXyoFlowed: statsContext?.totalXyoFlowed?.toString(10),
    totalXyoMintingRewards: statsContext?.totalXyoMintingRewards?.toString(10),
    totalXyoSpent: statsContext?.totalXyoSpent?.toString(10),
  }

  return (
    <Box padding={2}>
      <Paper>
        <Box bgcolor="white" display="flex" flexDirection="column" flexGrow={1} justifyContent="flex-start" margin={2} padding={2}>
          <Box display="flex" flexGrow={1} minHeight={320}>
            <JsonView src={statsJson} />
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" margin={1}>
          <Button component={Link} to={'/stats/'}>
            Back
          </Button>
          <Button onClick={onRefreshClicked}>Refresh</Button>
        </Box>
      </Paper>
    </Box>
  )
}

const StatsJsonPage: React.FC = () => {
  return (
    <WorldBasePage>
      <Helmet title="Geotoken Details" />
      <StatsLoader>
        <Container>
          <Details />
        </Container>
      </StatsLoader>
    </WorldBasePage>
  )
}

export default StatsJsonPage
